import gql from 'graphql-tag'

const mutation = gql`
	mutation rebootDevices($hardwareIds: [ID!]!) {
	rebootDevices(ids: $hardwareIds) {
		data {
			cmd_job_key
	    }
	    code
	    msg
	}
}`

export default mutation
